import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Observable, map, catchError, throwError } from 'rxjs';
import { environment } from '../services/global-environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private apiUrl = environment.apiUrl;
  private companyid = environment.companyid;

  constructor(private http: HttpClient) {}

  // 上傳單一檔案
  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
      formData.append('filename', file.name);
    formData.append('companyid', this.companyid);

    return this.http.post(`${this.apiUrl}/api/storage/upload`, formData, {
      reportProgress: true,
      observe: 'events',
      headers: new HttpHeaders({
        'Accept': 'application/json'
      })
    }).pipe(
      map(event => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          return {
            type: 'progress',
            progress: Math.round(100 * event.loaded / event.total)
          };
        } else if (event.type === HttpEventType.Response) {
          return {
            type: 'success',
            response: event.body
          };
        }
        return event;
      }),
      catchError(error => {
        console.error('檔案上傳失敗:', error);
        return throwError(() => error);
      })
    );
  }

  // 上傳多個檔案
  uploadMultipleFiles(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    formData.append('companyid', this.companyid);

    return this.http.post(`${this.apiUrl}/api/storage/upload`, formData, {
      reportProgress: true,
      observe: 'events',
      headers: new HttpHeaders({
        'Accept': 'application/json'
      })
    }).pipe(
      map(event => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          return {
            type: 'progress',
            progress: Math.round(100 * event.loaded / event.total)
          };
        } else if (event.type === HttpEventType.Response) {
          return {
            type: 'success',
            response: event.body
          };
        }
        return event;
      }),
      catchError(error => {
        console.error('批次檔案上傳失敗:', error);
        return throwError(() => error);
      })
    );
  }

  // 產生檔案瀏覽連結
  generateViewUrl(blobName: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/storage/view-url`, {
      blobName,
      companyid: this.companyid
    }).pipe(
      catchError(error => {
        console.error('產生瀏覽連結失敗:', error);
        return throwError(() => error);
      })
    );
  }

  // 產生檔案下載連結
  generateDownloadUrl(blobName: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/storage/download-url`, {
      blobName,
      companyid: this.companyid
    }).pipe(
      catchError(error => {
        console.error('產生下載連結失敗:', error);
        return throwError(() => error);
      })
    );
  }

  // 刪除檔案
  deleteFile(blobName: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/storage/delete`, {
      blobName,
      companyid: this.companyid
    }).pipe(
      catchError(error => {
        console.error('刪除檔案失敗:', error);
        return throwError(() => error);
      })
    );
  }

  // 批次產生瀏覽/下載連結
  batchGenerateUrls(blobNames: string[]): Observable<any> {
    const requests = blobNames.map(blobName => ({
      blobName,
      companyid: this.companyid
    }));

    return this.http.post(`${this.apiUrl}/api/storage/batch-urls`, {
      requests
    }).pipe(
      catchError(error => {
        console.error('批次產生連結失敗:', error);
        return throwError(() => error);
      })
    );
  }

  // 產生長效瀏覽連結（用於需要長時間顯示的圖片）
  generateLongTermViewUrl(blobName: string, expiryDays: number = 365): Observable<any> {
    const expiryMinutes = expiryDays * 24 * 60; // 轉換天數為分鐘
    return this.http.post(`${this.apiUrl}/api/storage/view-url`, {
      blobName,
      companyid: this.companyid,
      expiryMinutes // 傳遞自訂的過期時間
    }).pipe(
      catchError(error => {
        console.error('產生長效瀏覽連結失敗:', error);
        return throwError(() => error);
      })
    );
  }
}
